import React from 'react';

const FiltersContext = React.createContext();

// reducer
const reducer = (state, action) => {
  const clearedFilters = {conditions: null, minAge: null, maxAge: null, gender: null, pscore: null, mutationsIN: null, mutationsOUT: null, filtersHit: false};
  switch(action.type) {

    // login
    case 'setFilters':
    return {
      ...state,
			...action.query,
      filtersHit: true
    };

    default: return clearedFilters;
  }
};


// provider
const FiltersContextProvider = props => {

  const [state, dispatch] = React.useReducer(reducer, {
    conditions: null,
		minAge: null,
		maxAge: null,
		gender: null,
		pscore: null,
		mutationsIN: null,
		mutationsOUT: null,
    filtersHit: false
  });

  return(
    <FiltersContext.Provider
      value={{
        filters: state,
        filterAction: dispatch
      }}
    >
      {props.children}
    </FiltersContext.Provider>
  )
}

const FiltersContextConsumer = FiltersContext.Consumer;

export {FiltersContext, FiltersContextProvider, FiltersContextConsumer};
